<template>
<div>
  <b-card>
    <template v-slot:header
              v-if="username && email">
      <h4>Aktuelle E-Mail-Addresse:</h4>
      <h2>{{username}}</h2>
      <h2> {{email}}</h2>
    </template>
    <b-container>
      <div class="m-4">
        <b-button class="col-12"
                  v-if="!changeEmail"
                  @click="changeEmail = !changeEmail">
          Email Adresse ändern
        </b-button>
        <b-button class="col-12"
                  v-if="changeEmail"
                  @click="changeEmail = !changeEmail">
          Abbrechen
        </b-button>
      </div>
      <div v-if="changeEmail">
        <email-input @emitEmail="emitEmail"></email-input>
      </div>

      <div class="m-4" v-if="changeEmail">
        <b-button class="col-12"
                  v-if="newEmail"
                  :disabled="!newEmail"
                  :variant="newEmail? 'outline-success' : ''"
                  @click="saveEmail">
          Speichern
        </b-button>
      </div>
    </b-container>
  </b-card>
</div>
</template>

<script>
    import EmailInput from "../email-input";
    export default {
        name: "luma-user-email",
      components: {EmailInput},
      data:()=>({
        changeEmail:false,
        newEmail:'',
      }),
      props:{
          username:String,
          email:String
      },
      methods:{
          saveEmail(){
            this.changeEmail = !this.changeEmail
            this.$emit('saveEmail',this.newEmail)
          },
          emitEmail(val){
            this.changeEmail = true
            this.newEmail = val
          }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/account/details_account/luma-user-email.vue